var _defs, _ellipse, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeriesWorks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.45 57.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #333;\n      }\n\n      .cls-2 {\n        fill: #7cb497;\n      }\n    "))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 28.72,
    cy: 28.61,
    rx: 28.72,
    ry: 28.61
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 28.5,
    cy: 28.5,
    r: 24.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeriesWorks);
export default __webpack_public_path__ + "static/media/series-works.dc070cf36b4d61319c0042bef042a0d3.svg";
export { ForwardRef as ReactComponent };